import React from 'react';
import { Modal, Button, TextContainer } from '@shopify/polaris';

function PlanConfirmationModal({ isOpen, onClose, onConfirm, planName }) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={`Confirm Subscription for ${planName}`}
      primaryAction={{
        tone: "success",
        content: 'Confirm',
        onAction: () => {
          onConfirm();
          onClose();
        },
      }}
      secondaryActions={{
        content: 'Cancel',
        onAction: onClose,
      }}
    >
      <Modal.Section>
        <TextContainer>
          <p>
            Are you sure you want to subscribe to the <strong style={{textTransform: "capitalize"}}>{planName}</strong> plan?
          </p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
}

export default PlanConfirmationModal;



